const getSentry = async () => {
  if (import.meta.env.SSR) {
    return await import('@sentry/node');
  }

  return await import('@sentry/browser');
};

export default getSentry;
